import { ApiRequest, DemoApiMock } from '../types'
import { mockShiftTimeline } from './getShiftTimeline'
import { mockCreateLocation } from './createLocation'
import { mockGetLocations } from './getLocations'
import { mockGetPositions } from './getPositions'
import { mockCreatePosition } from './createPosition'
import { mockGetWorkers } from './getWorkers'
import { mockGetRosters } from './getRosters'
import { mockGetRosterDetails } from './getRosterDetails'
import { mockCreateRoster } from './createRoster'
import {
  mockUpdateRoster,
  mockAddWorkersToRoster,
  mockRemoveWorkerFromRoster,
  mockAddWorkerToRosters,
} from './updateRoster'
import { mockGetWorkerProfile } from './getWorkerProfile'
import { mockUpdateWorkerStatusForCompany } from './updateWorkerStatus'
import { mockGetShiftDetails } from './getShiftDetails'
import { mockGetCompanyMembers } from './getCompanyMembers'
import { mockGetDuplicateShifts } from './getDuplicateShifts'
import { mockCreateShift } from './createShift'
import {
  mockAddShiftBonus,
  mockCancelShift,
  mockCancelAssignmentShifts,
  mockUpdateShift,
} from './updateShift'
import { mockGetWorkerCompliments } from './getWorkerCompliments'
import {
  mockGetPendingReviewShifts,
  mockGetOvertimeReviewShifts,
  mockGetPendingTryoutReviewShifts,
} from './getReviews'
import {
  mockApproveWork,
  mockBulkApproveWork,
  mockUpdateWork,
} from './editWork'
import { mockGetPositionTemplateGroups } from './getPositionTemplateGroups'
import { mockUpdatePosition } from './updatePosition'
import { mockGetInsights } from './getInsights'
import { mockGetCompanyInfo } from './getCompanyInfo'
import { mockGetWhoami } from './getWhoami'
import { mockGetShiftTutorials } from './getShiftTutorials'
import { mockGetWorkBreaks } from './getWorkBreaks'
import { mockGetAssignment } from './getAssignment'
import { mockGetPendingCalloutShifts } from './getPendingCalloutShifts'
import { mockUpdateCallout } from './updateCallout'
import { mockAssignmentRemoveWorker } from './removeWorker'
import { mockAssignmentAddWorkers } from './requestWorkers'
import { mockAssignmentEditShiftTimes } from './editShiftTimes'
import { pulseMocks } from './getPulseData'

const mocks: DemoApiMock[] = [
  mockGetShiftTutorials,
  mockGetWorkBreaks,
  mockShiftTimeline,
  mockCreateLocation,
  mockGetLocations,
  mockGetPositions,
  mockCreatePosition,
  mockGetWorkers,
  mockGetRosters,
  mockGetRosterDetails,
  mockCreateRoster,
  mockUpdateRoster,
  mockAddWorkerToRosters,
  mockAddWorkersToRoster,
  mockRemoveWorkerFromRoster,
  mockGetWorkerProfile,
  mockUpdateWorkerStatusForCompany,
  mockGetShiftDetails,
  mockGetCompanyMembers,
  mockGetDuplicateShifts,
  mockCreateShift,
  mockAddShiftBonus,
  mockCancelShift,
  mockCancelAssignmentShifts,
  mockUpdateShift,
  mockGetWorkerCompliments,
  mockGetPendingReviewShifts,
  mockGetPendingTryoutReviewShifts,
  mockGetOvertimeReviewShifts,
  mockUpdateWork,
  mockBulkApproveWork,
  mockApproveWork,
  mockGetPositionTemplateGroups,
  mockUpdatePosition,
  mockGetInsights,
  mockGetCompanyInfo,
  mockGetWhoami,
  mockGetAssignment,
  mockGetPendingCalloutShifts,
  mockUpdateCallout,
  mockAssignmentRemoveWorker,
  mockAssignmentAddWorkers,
  mockAssignmentEditShiftTimes,
  ...pulseMocks,
]

export async function getMockData(request: ApiRequest) {
  for (const mock of mocks) {
    if (mock.shouldMock(request)) {
      return mock.getResponse(request) ?? null // null to prevent api pass-through
    }
  }

  // eslint-disable-next-line no-console
  console.log('No mock found for request', request)
  return undefined
}
